import React from 'react';
import Header from '../header/Header';
import Footer from '../footer';
import Notifications from '../notifications/Notifications';
import TenantSelect from '../tenant-select';
import Root from './Root';
import Tenant from './Tenant';
import jwtDecode from 'jwt-decode';

import { Router, redirectTo, useMatch, useLocation } from '@reach/router';

/**
 * 
 * @param {String} isAuthenticated 
 * @param {String} manywhoTenantId
 * @param {*} location
 * @description If there is a redirect query parameter in the current url
 * then this can be extracted so that the browser can forward to it.
 */
const getForwardUrl = (isAuthenticated, manywhoTenantId, location) => {
    const queryParams = new URLSearchParams(location.search);
    const redirect = queryParams.get('redirect');
    if (isAuthenticated && !manywhoTenantId && redirect) {
        return redirect;
    }
    return null;
};

/**
 * 
 * @param {Boolean} isAuthenticated
 * @param {String} currentLoggedInTenantId 
 * @param {String} authenticationToken 
 * @param {Array} editors 
 * @param {Boolean} isTenantSelectorOpen 
 * @param {React.Component} container
 * @description The base component that renders all parts of the application that needs
 * to display the header and footer.
 */
const Tooling = ({
    isAuthenticated,
    currentLoggedInTenantId,
    authenticationToken,
    editors,
    isTenantSelectorOpen,
    container,
}) => {
    const location = useLocation();
    const forwardUrl = getForwardUrl(isAuthenticated, currentLoggedInTenantId, location);
    if (forwardUrl) {
        redirectTo(forwardUrl);
    }

    const isSso = authenticationToken ? jwtDecode(authenticationToken).is_sso : false;
    const isProtectedUrl = useMatch('/:tenantid/*');
    const showTenantSelector = (isAuthenticated && !currentLoggedInTenantId && !isProtectedUrl) || isTenantSelectorOpen;
    return (
        <div className="draw">
            <Header />
            {showTenantSelector ? <TenantSelect container={container} /> : null}
            <Router className="full-screen-app-wrapper">
                <Root
                    path="/"
                    isAuthenticated={isAuthenticated}
                    currentLoggedInTenantId={currentLoggedInTenantId}
                />
                
                <Tenant
                    path=":tenantid/*"
                    authenticationToken={authenticationToken}
                    editors={editors}
                    isSso={isSso}
                />
            </Router>
            <Footer />
            <Notifications />
        </div>
    );
};

export default Tooling;
